import { UserBriefInfo } from '@spilca/accounting_ts/v1/auth_common/dtos_pb';

const createUserConstructor = ({
  phoneNumber,
  lastName,
  firstName,
  businessName,
  email,
  role,
  isLimited
}: Partial<UserBriefInfo.AsObject>) => {
  const request = new UserBriefInfo();

  if (firstName) {
    request.setFirstName(firstName);
  }
  if (lastName) {
    request.setLastName(lastName);
  }
  if (phoneNumber) {
    request.setPhoneNumber(phoneNumber);
  }
  if (businessName) {
    request.setBusinessName(businessName);
  }
  if (email) {
    request.setEmail(email);
  }
  if (role) {
    request.setRole(role);
  }

  if (isLimited) {
    request.setIsLimited(isLimited);
  }

  return request;
};

export default createUserConstructor;
